(() => {
  if (!('fonts' in document)) return;
  const lazyLoadFont600 = () => {
    const font = new FontFace(
      "Noto Sans Japanese",
      "url(https://cdn.shopifycdn.net/s/files/1/0618/0755/8812/files/notosansjapanese_n6.d8754639f715e36fd4906793561ab9465a057e40.woff2?v=1750236416) format('woff2')",
      {
        weight: "600",
        style: "normal",
        display: "swap"
      }
    );
    
    font.load().then(loadedFont => {
      document.fonts.add(loadedFont);
      document.documentElement.classList.add("noto-jp-n6-loaded");
    });
  };

  window.addEventListener('load', () => {
    setTimeout(() => {
      lazyLoadFont600();
    }, 2000);
  });
})()